import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'
import { buildCustomTrackers } from 'helpers/tracking'

import getAccountTrackingData from './getAccountTrackingData'

export default (state): any => {
  const accountTrackingData = getAccountTrackingData(state)

  const { trackEvent, trackViewEvent } = buildCustomTrackers({
    staticDataMap: ACCOUNT_TRACKING_EVENTS,
    persistentData: accountTrackingData,
  })

  return {
    trackViewEvent,
    trackEvent,
  }
}
